import { PageProps } from '..'
import { useProjectPrivateContext } from '../../context/projectContext'
import ProfitLossItemsViewBase from './view/'
import { projectPrivate } from '../../higher-order-components/projectPrivate'

type Props = PageProps

const ProfitLossItems = (props: Props) => {
  const { project } = useProjectPrivateContext()

  return <ProfitLossItemsViewBase {...props} currentProject={project} />
}

export default projectPrivate(ProfitLossItems)
